import { render, staticRenderFns } from "./AudanetTaskListSideMenu.vue?vue&type=template&id=1af8fac6&scoped=true"
import script from "./AudanetTaskListSideMenu.vue?vue&type=script&lang=js"
export * from "./AudanetTaskListSideMenu.vue?vue&type=script&lang=js"
import style0 from "./AudanetTaskListSideMenu.vue?vue&type=style&index=0&id=1af8fac6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af8fac6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1af8fac6')) {
      api.createRecord('1af8fac6', component.options)
    } else {
      api.reload('1af8fac6', component.options)
    }
    module.hot.accept("./AudanetTaskListSideMenu.vue?vue&type=template&id=1af8fac6&scoped=true", function () {
      api.rerender('1af8fac6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/audanettask/AudanetTaskListSideMenu.vue"
export default component.exports